export default "https://cdn-static.gokick.com/assets/ecb6814e4f4fd856ee5e2a82e5f087b2e6d90ad2/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";